module.exports = __webpack_public_path__ + "static/media/icon.b0895d61.png";